import React from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import './Add_installation.css'
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";


export default function Feedback({installDetails, setinstallDetails}) {

  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const locate = useLocation();
  const staffName = useSelector((state) => state.staffname);
  
    
   const [originalData, setOriginalData] = useState({});

  useEffect(() => {
          axios
            .post(apiUrl+"getdata-install", {
              leadId: locate.state?.leadId,
            })
            .then((res) => {
              setinstallDetails(res.data.message);
              setOriginalData(res.data.message); // Store original data for comparison
            });
        }, [locate.state?.leadId]);
  
        const handleChange = (e) => {
          const { name, value } = e.target;
          setinstallDetails((prev) => ({
            ...prev,
            feedback: {
              ...prev.feedback,
              [name]: value,
            },
          }));
        };
  const planMonth = Number(installDetails?.installplanDetails?.installplanMonth)||0;
const planAmount = Number(installDetails?.installplanDetails?.installplanAmount)||0;
const staticIpCost = Number(installDetails?.installplanDetails?.installstaticIpCost)||0;
const installationCost = Number(installDetails?.installplanDetails?.installinstalationCost)||0;
const routerCost = Number(installDetails?.installplanDetails?.installrouterCost)||0;
const otherCost = Number(installDetails?.installplanDetails?.installothersCost)||0;

const totalPlanAmount = planMonth * planAmount;

const baseAmount = totalPlanAmount + staticIpCost + installationCost + routerCost + otherCost;

const gstAmount = baseAmount * 0.18;

const orderValue = +(baseAmount + gstAmount).toFixed(2);


const formattedOrderValue = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR"
}).format(orderValue);

const plan = installDetails.installplanDetails || {};


const installrouterCost = Number(plan.routerSellingCost) || 0;
const installfiberCost = Number(plan.installfiberCost) || 0;
const installfiberCableMeter = Number(plan.installfiberCableMeter) || 0;
const installottPrice = Array.isArray(plan.installottPrice) ? Number(plan.installottPrice[0]) || 0 : 0;
const installothersCost = Number(plan.installothersCost) || 0;
const OrderScore = baseAmount
  - installrouterCost
  - (installfiberCableMeter * installfiberCost)
  - installottPrice
  - installothersCost;

console.log("OrderScore:", OrderScore);
console.log(baseAmount,'baseamout')

const formattedOrderScore = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR"
}).format(OrderScore);

  return (
    <div>

        <Container>
            <form>
        <div  className='plan-details-container-border mt-3 text-center'>
                            <p style={{ fontSize:"13px"}}  className='pt-2'><span className='text-primary'>{installDetails?.installplanDetails?.installfiberCableMeter}
                            </span> M, <span className='text-primary '>{installDetails?.installplanDetails?.installplanSpeed}
                            </span> Mbps, <span className='text-primary'> {installDetails?.installplanDetails?.installplanMonth}</span>Month @ <span className='text-primary'>Rs. {installDetails?.installplanDetails?.installplanAmount}
                            /-</span></p>
                            <p  style={{ fontSize:"13px"}}>Order Value @ <span className='text-primary'>Rs.{formattedOrderValue}/-</span>, OrderScore @ <span className='text-primary'>Rs.{formattedOrderScore}/-</span></p>
                            
                        </div>
                    

   <div className='mt-5 mb-4 feedback-installation-container '>
<Row>
  <Col>
      <label className='ms-5 mt-5'><strong>Feedback</strong></label>

  </Col>
  <Col>
  <label> Customer Id</label>
  <br/>
  <input type="text"  className='form-input-customer-id-feedback' placeholder='Enter Customer ID'   
                    value={installDetails?.feedback?.customerId}

            onChange={handleChange}
 />
  </Col>
  </Row>    <div className='text-center'>
                <textarea
                  type="text"
                  value={installDetails?.feedback?.notes}
                   onChange={handleChange}

                  style={{ textTransform: "capitalize", resize: "none",margin:"auto",width:"70%",height:"250px",background:"rgb(222, 250, 241)" }}
                  className=" box address-install"
                  placeholder="Enter Feddback ..."
                  name="notes"
                />
                    {installDetails?.feedback?.isCompleted && (
  <p className='text-center mb-0 me-3 feedback-collectedby-feedback'>
    Collected By <span className='text-primary'>{installDetails?.feedback?.updatedBy}</span> At 
    <span className='text-primary'> {installDetails?.feedback?.updatedDate} {installDetails?.feedback?.updatedTime}</span>
  </p>
)}


        {/* <p className='ms-5 me-5 mt-4' >Our service are very nice and company staffs are vry humble. Especially fiber team is very good</p> */}
        </div>



   </div>
            </form>
        </Container>
    </div>
  )
}
